namespace $.$$ {
	$mol_style_define($easyreels_user_recordings, {
		flex: {
			direction: 'column',
		},
		gap: $mol_gap.block,
	})
}
